import React from 'react';
import { Link } from 'react-router-dom';

import { Segment, Menu } from 'semantic-ui-react'

import AuthUserContext from '../Session/AuthUserContext';
import SignOutButton from '../SignOut';
import * as routes from '../../constants/routes';

class Navigation extends React.Component {
  state = { activeItem: '' }

  handleItemClick = (e, { name }) => this.setState({ activeItem: name })

  NavigationNonAuth = () =>
  <React.Fragment>
    <Menu.Item
      name='landing'
      active={this.state.activeItem === 'landing'}
      onClick={this.handleItemClick}>
      <Link to={routes.LANDING}>Landing</Link>
    </Menu.Item>
    <Menu.Item
      name='signin'
      active={this.state.activeItem === 'signin'}
      onClick={this.handleItemClick}>
      <Link to={routes.SIGN_IN}>Sign In</Link>
    </Menu.Item>
  </React.Fragment>

  NavigationAuth = () =>
  <React.Fragment>
    <Link to={routes.LANDING}>
      <Menu.Item
        name='landing'
        active={this.state.activeItem === 'landing'}
        onClick={this.handleItemClick}>
        Landing
      </Menu.Item>
    </Link>
    <Link to={routes.HOME}>
      <Menu.Item
        name='home'
        active={this.state.activeItem === 'home'}
        onClick={this.handleItemClick}>
        Home
      </Menu.Item>
    </Link>
    <Link to={routes.ACCOUNT}>
      <Menu.Item
        name='account'
        active={this.state.activeItem === 'account'}
        onClick={this.handleItemClick}>
        Account
      </Menu.Item>
    </Link>
    <Menu.Menu position='right'>
      <SignOutButton />
    </Menu.Menu>
  </React.Fragment>

  render() {
    const custom = {
      marginTop: '0px',
      borderRadius: '0px',
      backgroundColor: '#1e3d4a',
      borderWidth: '0px',
      borderColor: 'transparent'
    };

    return (
      <Segment
        inverted
        style={custom}>
        <Menu
          inverted
          pointing
          secondary
          stackable
          borderless
          style={custom}>
          <AuthUserContext.Consumer>
            {authUser => authUser
              ? this.NavigationAuth()
              : this.NavigationNonAuth()
            }
          </AuthUserContext.Consumer>
        </Menu>
      </Segment>
    )
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js